// @flow
import styled from 'styled-components';

export const FilledIcon = styled.div`
	background: ${({ background }) => background || 'transparent'};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${({ size }) => size ? `${size}em` : '30px'};
	height: ${({ size }) => size ? `${size}em` : '30px'};
	transition: all 0.2s;

	// > svg {
	// 	padding: ${({ padding }) => padding || '.25em'};
	// 	box-sizing: border-box;
	// }
`;

export default FilledIcon;


// WEBPACK FOOTER //
// ./src/components/FilledIcon/index.js